import { render, staticRenderFns } from "./SystemMailbox.vue?vue&type=template&id=2bf03278"
import script from "./SystemMailbox.vue?vue&type=script&lang=js"
export * from "./SystemMailbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports